angular = require('angular')
class ResourceFactory
  @$injector: ['RestfulResource', '$http', '$cookies', "Upload", 'config']
  constructor: (RestfulResource, $http, $cookies, Upload, config)->    
    url = "#{config.api.url}/resources/"    
    actions =       
      list:
        medthod: 'GET'
        url: "#{url}/list"
        isArray: true
      parents:
        medthod: 'GET'
        url: "#{url}/:_id/parents/"
        isArray: true

    Resource = new RestfulResource("#{url}/:_id", {_id: "@_id"}, actions)         
    Resource.upload = (file, folder)->        
      Upload.upload
        url: "#{url}"
        data:
          file: file        
          folder: folder?._id
    Resource.prototype.$thumbnail = ()->        
        return "#{url}#{@_id}/thumbnail?access_token=#{$cookies.get('token')}"

    Resource.prototype.$assign = (company)->        
        $http
          method: "POST"
          url: "api/companies/#{company._id}/resources/"
          data: @
        .then (result)->
          return result.data
          
    Resource.prototype.$download = ()->
        window.location = "#{url}/#{@_id}/source?access_token=#{$cookies.get('token')}"
    return Resource
module.exports = ResourceFactory




// WEBPACK FOOTER //
// ./src/component/resource/resource.coffee